import type { LevelDefinition } from "@/domain";

import {
  pictureCharacterMatchLevels,
  type PictureCharacterMatchPayload
} from "./picture-character-match";
import {
  soundBubbleLevels,
  type SoundBubblePayload
} from "./sound-bubbles";
import {
  storySequenceLevels,
  type StorySequencePayload
} from "./story-sequence";

export {
  pictureCharacterMatchLevels,
  soundBubbleLevels,
  storySequenceLevels
};
export type {
  CharacterMatchItem,
  PictureCharacterAnswer,
  PictureCharacterMatchPayload,
  PictureMatchItem
} from "./picture-character-match";
export type {
  SoundBubbleChoice,
  SoundBubblePayload
} from "./sound-bubbles";
export type {
  StorySequenceItem,
  StorySequencePayload
} from "./story-sequence";

export type ChineseLevelPayload =
  | SoundBubblePayload
  | PictureCharacterMatchPayload
  | StorySequencePayload;

export const chineseLevels: LevelDefinition<ChineseLevelPayload>[] = [
  ...soundBubbleLevels,
  ...pictureCharacterMatchLevels,
  ...storySequenceLevels
];
